import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { paymentShape } from 'constants/propTypes';
import { codes } from 'constants/payment';
import { isPrrRefundPayment } from 'utils/payment';
import { PaymentReferenceContent, VoucherPaymentReferenceLink } from './PaymentsSummary.styles';

const PaymentReference = ({ payment, onVoucherReferenceClick, onVoucherAliasClick }) => {
  if (payment.isPayout && payment.method === codes.EVOUCHER && !isPrrRefundPayment(payment)) {
    const reference = payment.reference.endsWith('-overpaid') ? payment.reference.slice(0, -9) : payment.reference;
    const content = reference
      .slice(-16)
      .replace('_', '-') // '_' was used for old datacash vouchers
      .split('-')
      .pop();

    return (
      <VoucherPaymentReferenceLink data-testid="payment-reference" onClick={() => onVoucherAliasClick(content)}>
        {`...${content.substr(-4)}`}
      </VoucherPaymentReferenceLink>
    );
  }
  if (payment.method === codes.WRITE_OFF) {
    return <PaymentReferenceContent data-testid="payment-reference">{payment.reference?.split('-')?.[0] ?? ''}</PaymentReferenceContent>;
  }

  if (payment.method === codes.BLUE_VOUCHER) {
    return (
      <PaymentReferenceContent data-testid="payment-reference">
        {payment.reference?.split('-')?.[payment.isPayout ? 3 : 0] ?? ''} &nbsp;
        <FormattedMessage id="paymentsSummary.vouchers" />
      </PaymentReferenceContent>
    );
  }

  if (payment.method === codes.VOUCHER) {
    return (
      <VoucherPaymentReferenceLink data-testid="payment-reference" onClick={() => onVoucherReferenceClick(payment.reference)}>
        {`...${payment.reference}`}
      </VoucherPaymentReferenceLink>
    );
  }
  if (payment.method === codes.LOYALTY_POINTS) {
    const pointsStrIndex = payment.isPayout ? 3 : 0;
    const points = payment.reference?.includes('-') ? payment.reference.split('-')[pointsStrIndex] : undefined;

    return (
      <PaymentReferenceContent data-testid="payment-reference">
        {points && !Number.isNaN(Number(points)) ? `${points} points` : ''}
      </PaymentReferenceContent>
    );
  }

  if (payment.isPayout && payment.method === codes.CARD) {
    const content = payment.reference?.split('-')?.[3] ?? '';

    return <PaymentReferenceContent data-testid="payment-reference">{content}</PaymentReferenceContent>;
  }

  if (!payment.isPayout) {
    return <PaymentReferenceContent data-testid="payment-reference">{payment.reference}</PaymentReferenceContent>;
  }

  return <PaymentReferenceContent data-testid="payment-reference" />;
};

PaymentReference.propTypes = {
  payment: paymentShape,
  onVoucherReferenceClick: PropTypes.func,
  onVoucherAliasClick: PropTypes.func
};

export default PaymentReference;
